// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContractDto } from '@ellf/common-dto';
import { FilterValue, PagedResultDto } from '@ellf/common-interfaces';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class ContractApiClient extends BaseCRUDApiClient<ContractDto> {
  baseUrl = this.config.apiEndpoint + '/contract';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
